"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputToPts = void 0;
/**
 * - If the length of the digits is less than 4, returns the original string.
 * - If the length is 3 or more, returns string with comma for every 3 digits from the right.
 *
 * @param {string} amount - The value to be formatted.
 * @returns {string} - The formatted digit, or original/empty string based on conditions.
 */
const inputToPts = (amount) => {
    if (!amount)
        return amount;
    let toReturn = amount.trim().replace(/[^\d]/g, "");
    const parts = toReturn.split(".");
    let whole = parts[0];
    // places a comma for every 3 digits from the right
    if (whole.length > 3) {
        whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    toReturn = `${whole}`;
    return toReturn;
};
exports.inputToPts = inputToPts;
